import { createContext, useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom"; 
import { rootApi } from "./axiosInstance";
 
const AuthContext = createContext();
 
export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();  
  const [auth,setAuth]=useState(false);

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [serverError, setServerError] = useState("");
 
  const parseJwt = (token) => {
    try {
      return JSON.parse(atob(token.split('.')[1]));
    } catch (e) {
      return null;
    }
  };
 
  useEffect(() => {
    const checkUser = () => {
      const token = localStorage.getItem("accessToken");
      const loginSuccess = localStorage.getItem("login_success") === "true";
      const storedUserData = localStorage.getItem("user_data");

      if (token) {
        const decoded = parseJwt(token);
        if (decoded) {
          setUser({ ...decoded, name: decoded.name || decoded.sub });
        }
      } else if (loginSuccess && storedUserData) {
        const userData = JSON.parse(storedUserData);
        setUser({
          name: userData.fullName,
          email: userData.email,
          role: "applicant"
        });
      }
      setLoading(false);
    };
    checkUser();
  }, []);
 
  const normalizeRole = (role) => {
    if (!role) return "applicant";
    const lowerRole = role.toLowerCase();
    if (lowerRole === "user" || lowerRole === "applicant") return "applicant";
    if (lowerRole === "admin") return "admin";
    return "applicant";
  };

  const handleAuthResponse = (data) => {
    const accessToken = data.accessToken || data.access_token;
    const refreshToken = data.refreshToken || data.refresh_token;
   
    if (accessToken) {
      localStorage.setItem("accessToken", accessToken);
      if (refreshToken) localStorage.setItem("refreshToken", refreshToken);
 
      const decodedUser = parseJwt(accessToken);
      const userData = data.user || decodedUser || { email: "User" };
     
      const rawRole = userData.role || decodedUser?.role || "applicant";
      const role = normalizeRole(rawRole);
     
      const appId = userData.app_id || userData.id;
      if (appId) localStorage.setItem("app_id", appId);
 
      localStorage.setItem("userRole", role);
 
      setUser({ ...userData, role, app_id: appId });
      return { success: true, role, app_id: appId };
    } else {
        throw "Token missing in response";
    }
  };
 
const login = async (email, password) => {
  setIsSubmitting(true);
  try {
    const rawData = localStorage.getItem('user_data') || "[]";
    const allUsers = JSON.parse(rawData);
    
    // ఖచ్చితంగా Array అని కన్ఫర్మ్ చేసుకోవాలి
    const usersArray = Array.isArray(allUsers) ? allUsers : (allUsers.email ? [allUsers] : []);
    
    // ఈమెయిల్ ని చిన్న అక్షరాలుగా మార్చి వెతకాలి (Case Sensitivity Fix)[cite: 35]
    const userFound = usersArray.find(u => 
      u.email.toLowerCase().trim() === email.toLowerCase().trim()
    );
    
    if (userFound && userFound.password === password) {
      localStorage.setItem('login_success', 'true');
      
      const sessionUser = {
        name: userFound.fullName,
        email: userFound.email,
        role: "applicant"
      };
      
      localStorage.setItem('current_user', JSON.stringify(sessionUser));
      setUser(sessionUser);
      setSuccessMessage(`Welcome ${userFound.fullName}`);
      setServerError('');
      
      setTimeout(() => navigate('/'), 1500);
      return true;
    }
    
    setServerError('Invalid email or password.');
    return false;
  } catch (error) {
    setServerError('Login failed. Please try again.');
    return false;
  } finally {
    setIsSubmitting(false);
  }
};

const logout = () => {
  // కేవలం సెషన్ వివరాలను మాత్రమే తీసేయాలి, 'user_data' (మొత్తం యూజర్లు) అలాగే ఉండాలి
  localStorage.removeItem("accessToken");
  localStorage.removeItem("refreshToken");
  localStorage.removeItem("login_success");
  localStorage.removeItem("current_user"); // ప్రస్తుత యూజర్ ని తీసేయాలి
  
  setUser(null);
  window.location.href = "/";
};

  const registerUser = async (name, email, password) => {
    try {
      const res = await rootApi.post("/auth/register", { name, email, password });
      return res.data;
    } catch (error) {
      throw error.response?.data?.error || "Registration failed";
    }
  };
 
  const loginWithGoogle = async (token) => {
    try {
      const res = await rootApi.post("/auth/google", { token });
      return handleAuthResponse(res.data);
    } catch (error) {
      throw error.response?.data?.error || "Google login failed";
    }
  };
 
  const updateUser = async (data) => {
    try {
        const res = await rootApi.put("/auth/user", data);
        return res.data;
    } catch (error) {
        throw error.response?.data?.error || "Failed to update profile";
    }
  };
 
  {/*const logout = () => {
    localStorage.clear(); 
    setUser(null);
    window.location.href = "/"; 
  };*/}
 
  return (
    <AuthContext.Provider value={{
      user, loading, 
      registerUser, loginWithGoogle, updateUser, logout, login,
      isSubmitting, successMessage, serverError ,auth,setAuth
    }}>
      {!loading && children}
    </AuthContext.Provider>
  );
};
 
export const useAuth = () => useContext(AuthContext);